import AvailabilityTypes from './AvailabilityTypes';

export default AvailabilityTypes;